import ConfirmationDialog from "@/components/ui/confirmation-dialog"
import { useToast } from "@/components/ui/use-toast"
import { gql } from "@/generated"
import { cn } from "@/lib/utils"
import { rootPath } from "@/novus/novus-paths"
import { useMutation } from "@apollo/client"
import React, { useState } from "react"
import { useNavigate } from "react-router-dom"

const DeleteFiveTwoNineAccount_Mutation = gql(`
  mutation DeleteFiveTwoNineAccount($input: DeleteFiveTwoNineAccountInput!) {
    deleteFiveTwoNineAccount(input: $input) {
      errors {
        fullMessages
      }
    }
  }
`)

const DeleteFiveTwoNineAccountButton = ({ id }: { id: string }) => {
  const [mutate, { loading }] = useMutation(DeleteFiveTwoNineAccount_Mutation)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const { toast } = useToast()
  const navigate = useNavigate()

  const deleteFiveTwoNineAccount = async () => {
    try {
      mutate({
        variables: {
          input: {
            id: id,
          },
        },
      })
      toast({
        title: "Beneficiary has been removed.",
      })
      navigate(rootPath.pattern)
    } catch (error) {
      console.error(error)
      toast({
        title: "Beneficiary was not removed, please try again.",
        variant: "destructive",
      })
    }
  }

  return (
    <div>
      <button
        onClick={() => setShowConfirmation(true)}
        disabled={loading}
        className={cn("text-textPink text-sm", "hover:opacity-75")}
      >
        Remove Beneficiary
      </button>
      <ConfirmationDialog
        title="Are you sure?"
        description="Please confirm that you would like to remove this beneficiary."
        actionName="Remove Beneficiary"
        onConfirm={() => {
          deleteFiveTwoNineAccount()
          setShowConfirmation(false)
        }}
        isOpen={showConfirmation}
        setIsOpen={setShowConfirmation}
      />
    </div>
  )
}

export default DeleteFiveTwoNineAccountButton
